import React from 'react';
import { useTranslation } from 'react-i18next';
import { Mic, ArrowRight, Users, MessageSquare } from 'lucide-react';

export const HowItWorks: React.FC = () => {
  const { t } = useTranslation();
  
  const steps = [
    {
      icon: <Mic className="h-8 w-8 text-indigo-600" />,
      title: t('howItWorks.steps.speak.title'),
      description: t('howItWorks.steps.speak.description')
    },
    {
      icon: <ArrowRight className="h-8 w-8 text-indigo-600" />,
      title: t('howItWorks.steps.process.title'),
      description: t('howItWorks.steps.process.description')
    },
    {
      icon: <MessageSquare className="h-8 w-8 text-indigo-600" />,
      title: t('howItWorks.steps.translate.title'),
      description: t('howItWorks.steps.translate.description')
    },
    {
      icon: <Users className="h-8 w-8 text-indigo-600" />,
      title: t('howItWorks.steps.understand.title'),
      description: t('howItWorks.steps.understand.description')
    }
  ];

  return (
    <section id="how-it-works" className="py-16 md:py-24">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            {t('howItWorks.title')}
          </h2>
          <p className="text-xl text-gray-600">
            {t('howItWorks.subTitle')}
          </p>
        </div>
        
        <div className="relative">
          {/* Connection line */}
          <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-indigo-100 hidden md:block" style={{ transform: 'translateX(-50%)' }}></div>
          
          <div className="space-y-12 relative">
            {steps.map((step, index) => (
              <div 
                key={index} 
                className="md:flex items-center"
                data-aos={index % 2 === 0 ? "fade-right" : "fade-left"}
              >
                <div className={`md:w-1/2 ${index % 2 === 0 ? 'md:pr-16 lg:pr-24' : 'md:order-2 md:pl-16 lg:pl-24'}`}>
                  <div className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 hover:shadow-md transition-all duration-300">
                    <div className="mb-4 flex md:hidden items-center justify-center w-12 h-12 bg-indigo-100 rounded-full">
                      {step.icon}
                    </div>
                    <h3 className="text-xl font-semibold text-gray-900 mb-3">{step.title}</h3>
                    <p className="text-gray-600">{step.description}</p>
                  </div>
                </div>
                
                <div className={`hidden md:flex md:w-1/2 ${index % 2 === 0 ? 'md:order-2 md:justify-start' : 'md:justify-end'}`}>
                  <div className="relative flex items-center justify-center">
                    {/* Circle with number */}
                    <div className="w-16 h-16 rounded-full bg-indigo-600 flex items-center justify-center text-white text-xl font-bold z-10">
                      {index + 1}
                    </div>
                    {/* Icon */}
                    <div className="absolute w-24 h-24 bg-indigo-100 rounded-full flex items-center justify-center">
                      {step.icon}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
